import { CheckIcon } from '@/components/icons';
import { form, success } from '@/config/collectionsLanding';

export default function SuccessState({ invoicingPlatform }: { invoicingPlatform: string }) {
  const platformOpt = form.invoicingPlatform.options.find((o) => o.value === invoicingPlatform);
  const showPlatform =
    platformOpt && invoicingPlatform !== 'none' && invoicingPlatform !== 'other';

  return (
    <div className="rounded-2xl border border-emerald-100 bg-white p-8 text-center shadow-sm">
      <span className="mx-auto grid h-16 w-16 place-items-center rounded-full bg-emerald-100 text-emerald-600">
        <CheckIcon width={32} height={32} />
      </span>
      <h3 className="mt-5 text-2xl font-extrabold text-ink-900">{success.title}</h3>
      <p className="mx-auto mt-3 max-w-md text-base leading-relaxed text-ink-600">{success.body}</p>
      {showPlatform && (
        <p className="mx-auto mt-4 max-w-md rounded-xl bg-brand-50 px-4 py-3 text-sm font-medium text-brand-800">
          {success.platformLine.replace('{platform}', platformOpt!.label)}
        </p>
      )}
    </div>
  );
}
